import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-edit.png'

const EditBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default EditBtn
